import React from "react";
import { FormGroup } from "@cofano/cck";
import { Language } from "imports/Utils";
import { FormattedDate } from "utils/DateUtils";
import { IdtfGoodFragment } from "__generated__/view/products/graphql/product.fragments.generated";

const ProductIdtfDetails = ({ idtfGood }: { idtfGood?: IdtfGoodFragment | null }) => {
	return (
		<React.Fragment>
			<FormGroup label={Language("PRODUCT_IDTF_NUMBER")} overflow="hidden">
				{idtfGood?.idtfNumber || "-"}
			</FormGroup>

			<FormGroup label={Language("PRODUCT_IDTF_VALID_FROM")} overflow="hidden">
				{idtfGood?.validFrom ? <FormattedDate date={idtfGood.validFrom} format="ll" /> : "-"}
			</FormGroup>

			<FormGroup label={Language("PRODUCT_IDTF_GROUP")} overflow="hidden">
				{idtfGood?.groupName || "-"}
			</FormGroup>

			<FormGroup label={Language("PRODUCT_IDTF_PRODUCT_NAME")}overflow="visible">
				{idtfGood?.productName || "-"}
			</FormGroup>

			<FormGroup label={Language("PRODUCT_IDTF_CLEANING_REGIME")} overflow="visible">
				{idtfGood?.cleaningRegime || "-"}
			</FormGroup>

			<FormGroup label={Language("PRODUCT_IDTF_IMPORTANT_REQUIREMENT")} overflow="visible">
				{idtfGood?.importantRequirement || "-"}
			</FormGroup>
		</React.Fragment>
	);
};

export default ProductIdtfDetails;
